import React from 'react';

/**
 * ChatBubble - Chat-style message display
 */
const ChatBubble = ({ message, isOwn = false }) => {
    const formatTime = (dateStr) => {
        if (!dateStr) return '';
        try {
            return new Date(dateStr).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
        } catch {
            return '';
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);

            if (date.toDateString() === today.toDateString()) {
                return 'Today';
            }
            if (date.toDateString() === yesterday.toDateString()) {
                return 'Yesterday';
            }
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        } catch {
            return '';
        }
    };

    return (
        <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-4`}>
            <div className={`
                max-w-[80%] sm:max-w-[70%]
                ${isOwn ? 'order-2' : 'order-1'}
            `}>
                {/* Sender info */}
                {!isOwn && message.sender_name && (
                    <p className="text-xs font-medium text-slate-500 mb-1 ml-3">
                        {message.sender_name}
                    </p>
                )}

                {/* Message bubble */}
                <div className={`
                    relative px-4 py-3 rounded-2xl shadow-sm
                    ${isOwn
                        ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-br-md'
                        : 'bg-white border border-slate-200 text-slate-900 rounded-bl-md'}
                `}>
                    <p className="text-sm whitespace-pre-wrap break-words">
                        {message.body || message.content || message.summary || 'Message'}
                    </p>

                    {/* Attachments */}
                    {message.attachments?.length > 0 && (
                        <div className="mt-2 space-y-1">
                            {message.attachments.map((att, idx) => (
                                <div
                                    key={idx}
                                    className={`
                                        flex items-center gap-2 px-2 py-1 rounded-lg text-xs
                                        ${isOwn ? 'bg-white/10' : 'bg-slate-50'}
                                    `}
                                >
                                    <span>📎</span>
                                    <span className="truncate">{att.name || 'Attachment'}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Time and status */}
                <div className={`
                    flex items-center gap-2 mt-1 text-xs text-slate-400
                    ${isOwn ? 'justify-end mr-2' : 'ml-3'}
                `}>
                    <span>{formatTime(message.created_at)}</span>
                    {message.showDate && (
                        <span>· {formatDate(message.created_at)}</span>
                    )}
                    {isOwn && (
                        <span className={message.read ? 'text-indigo-500' : ''}>
                            {message.read ? '✓✓' : '✓'}
                        </span>
                    )}
                </div>
            </div>

            {/* Avatar for received messages */}
            {!isOwn && (
                <div className="h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center text-sm font-medium text-slate-600 ml-2 flex-shrink-0 order-0">
                    {message.sender_name?.charAt(0) || 'R'}
                </div>
            )}
        </div>
    );
};

export default ChatBubble;
